import { makeStyles } from "@material-ui/core/styles";


export default makeStyles(()=>({
    income: {
        borderBottom: '10px solid rgba(4, 147, 114, 1)',
    },
    expense: {
        borderBottom: '10px solid rgba(139,0,0 ,1 )',
    }
}));